export default {
  getRelatorios ({ relatorios }) {
    return relatorios
  }
}
